/**
 * Synchronize Hero Slider active changes with secondary product panels
 * Handles both real index checking and infinite duplicate buffers seamlessly.
 */
if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiperContainer = this;
      this.initSliderLoop();
    }

    initSliderLoop() {
      if (typeof Swiper === 'undefined') return;

      const isAutoplay = this.dataset.autoplay === 'true';
      const autoplayInterval = parseInt(this.dataset.autoplayInterval) || 6000;
      const sectionRoot = this.closest('.hero-banner-wrapper');
      
      const actualSlideCount = this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length || 8;

      this.sliderInstance = new Swiper(this, {
        direction: 'horizontal',
        loop: true,                 
        loopedSlides: actualSlideCount,            
        loopAdditionalSlides: 2,    
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        autoplay: isAutoplay ? { delay: autoplayInterval, disableOnInteraction: false } : false,
        
        navigation: {
          nextEl: this.querySelector('.swiper-button--next'),
          prevEl: this.querySelector('.swiper-button--prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (!sectionRoot) return;
            
            const currentRealIndex = this.realIndex; 
            const collectionPanels = sectionRoot.querySelectorAll('.hero-collection-panel');
            
            collectionPanels.forEach(panel => {
              const panelIndex = parseInt(panel.getAttribute('data-collection-panel-index'));
              
              if (panelIndex === currentRealIndex) {
                panel.classList.add('is-active');
                
                // SAFE CHECK: Re-initialize or update nested swiper instances inside active tabs if they exist
                const nestedSwiperNode = panel.querySelector('.card-product-slider');
                if (nestedSwiperNode && nestedSwiperNode.swiper) {
                  nestedSwiperNode.swiper.update();
                }
              } else {
                panel.classList.remove('is-active');
              }
            });
          }
        }
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
}